<template>
    <p>These examples use <a class="link-external" href="https://vuejs.org/" target="_blank">Vue.js 3</a> with <a class="link-external" href="https://tailwindcss.com/" target="_blank">Tailwind CSS v3.0</a>.</p>
</template>

<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: "Intro"
    });
</script>